import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import evidence_not_file from '../../asset/img/evidence_not_file.svg';
import Typography from '../../components/common/Typography';

const NotDocumentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  gap: 20px;
`;

const NotDocument = () => {
  const { t } = useTranslation('evidenceDocuments');
  return (
    <NotDocumentWrapper>
      <div>
        <img src={evidence_not_file} alt="notfile" />
      </div>
      <div className="displayFlexColumn" style={{ gap: '8px', alignItems: 'center' }}>
        <Typography variant="body1Bold">{t('notDocumentTitle')}</Typography>
        <Typography variant="body2Medium" style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
          {t('notDocumentDescription')}
        </Typography>
      </div>
    </NotDocumentWrapper>
  );
};

export default NotDocument;
